import { ifProp } from 'styled-tools';
import styled, { css } from 'styled-components';
import { fontBody } from 'Styles/fonts';
import { convertColorToThemeHexCode } from 'Styles/colors.util';

export const Input = styled.input`
  ${fontBody(16)};
  padding: 10.5px 12px;
  background-color: #FFF;
  border-radius: 3px;
  border-style: solid;
  width: 100%;
  border-color: ${ifProp(
    'hasError',
    convertColorToThemeHexCode('red'),
    convertColorToThemeHexCode('grey40')
  )};
  border-width: ${ifProp('hasError', '2px', '1px')};
  padding-left: ${ifProp('hasError', '11px', '12px')};
  color: var(--foreground);
  outline: none;
  resize: vertical;
  margin: 0;
  appearance: none;
  text-align: left;

  &:disabled {
    background: var(--hover);
  }

  &:focus {
    border: solid 2px var(--primary);
  }

  &::placeholder {
    color: var(--muted-foreground);
  }

  ${({ hasError, isFocused, isEmpty }) => {
    if (hasError || isFocused) {
      return css`
        padding: 16px 11px 3px;
      `;
    }

    if (!isEmpty)
      return css`
        padding: 17px 12px 4px;
      `;
  }}

  /* stylelint-disable property-no-vendor-prefix */
  &[type='date'] {
    -webkit-appearance: none;
    appearance: none;
    text-align: left;
    text-align-last: left;
    -webkit-text-align-last: left;
  }
  /* stylelint-enable property-no-vendor-prefix */
`;

export const Error = styled.p`
  ${fontBody(14)}
  color: ${convertColorToThemeHexCode('red')};
  margin: 6px 0 0 12px;
`;
